import { trpc } from '@/shared/api';

/**
 * 기획전에 묶인 상품(숨김·삭제 포함) — 상품 관리 모달이 상태와 함께 보여 준다.
 * 지워진 기획전은 NOT_FOUND 로 온다 — 재시도해도 결과가 같아 전역 기본값(retry: 1)을 끈다
 * (web 의 use-exhibition-query 와 같은 패턴).
 */
export const useExhibitionProductsQuery = (exhibitionId: string) =>
  trpc.productManagement.exhibitions.listProducts.useQuery({ exhibitionId }, { retry: false });
